import { render, staticRenderFns } from "./TableEmptyState.vue?vue&type=template&id=deaacefa&scoped=true"
import script from "./TableEmptyState.vue?vue&type=script&lang=js"
export * from "./TableEmptyState.vue?vue&type=script&lang=js"
import style0 from "./TableEmptyState.vue?vue&type=style&index=0&id=deaacefa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deaacefa",
  null
  
)

export default component.exports